<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'DisputesTableRestBreaksIndicator',
  mixins: [baseMixin],
  props: {
    compliant: {
      type: Boolean,
    },
  },
  computed: {
    compIcon() {
      return this.compliant ? 'mdi-check' : 'mdi-close'
    },
    compTooltipText() {
      return this.compliant
        ? this.$t('dispute.restBreaks.yesTooltip')
        : this.$t('dispute.restBreaks.noTooltip')
    },
    showIndicator() {
      return this.compliant !== null
    },
  },
}
</script>

<template>
  <div v-if="showIndicator" class="cursor-help">
    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on">{{ compIcon }}</v-icon>
      </template>
      <span class="ws-pre-wrap">{{ compTooltipText }}</span>
    </v-tooltip>
  </div>
</template>
